export const getUserName = (firstName?: string | null, lastName?: string | null) => {
  if (!firstName && !lastName) {
    return null;
  }

  return `${firstName || ''} ${lastName || ''}`;
};
